import React, { useMemo, useState } from 'react';
import { Button } from './Button';
import { ShieldCheck, Lock, CheckCircle, Circle, Rocket, Sparkles, Check } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { UpsellPopup } from './UpsellPopup';
// Shopify cart permalinks for each combination
const CHECKOUT_URLS = {
  base: 'https://tumentesoberana.com/cart/48520192164059:1',
  bump1Only: 'https://tumentesoberana.com/cart/48579486384347:1',
  bump2Only: 'https://tumentesoberana.com/cart/48579492970715:1',
  both: 'https://tumentesoberana.com/cart/48579487170779:1'
};
const BASE_PRICE = 9;
const BUMP_PRICE = 7;
export function PricingSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  const totalPrice = useMemo(() => {
    return BASE_PRICE + (bump1 ? BUMP_PRICE : 0) + (bump2 ? BUMP_PRICE : 0);
  }, [bump1, bump2]);
  const originalTotal = useMemo(() => {
    return 67 + (bump1 ? BUMP_PRICE : 0) + (bump2 ? BUMP_PRICE : 0);
  }, [bump1, bump2]);
  const checkoutUrl = useMemo(() => {
    if (bump1 && bump2) return CHECKOUT_URLS.both;
    if (bump1) return CHECKOUT_URLS.bump1Only;
    if (bump2) return CHECKOUT_URLS.bump2Only;
    return CHECKOUT_URLS.base;
  }, [bump1, bump2]);
  const handleCheckoutClick = (e: React.MouseEvent) => {
    if (!bump1 && !bump2) {
      e.preventDefault();
      setShowUpsell(true);
    }
  };
  return <section id="pricing" className="py-24 bg-[#060919] relative border-t border-white/5 overflow-hidden" data-id="element-146">
      <UpsellPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} data-id="element-147" />

      {/* Mystical glow behind pricing */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-yellow-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-148"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-149">
        <div className="text-center mb-12" data-id="element-150">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-151">
            Recupera tu paz y tu poder{' '}
            <span className="text-yellow-400" data-id="element-152">hoy mismo</span>.
          </h2>
          <p className="text-xl text-gray-300" data-id="element-153">
            Obtén la Guía Maestra + Los 3 Bonos Exclusivos por un precio de
            lanzamiento único.
          </p>
        </div>

        <div className="bg-gradient-to-b from-#[\\#1a1f3a] to-#[\\#0a0e27] border-2 border-yellow-500\\/50 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.15)] relative" data-id="element-154">
          {/* Badge */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-yellow-600 text-slate-900 font-bold px-6 py-2 rounded-full shadow-lg whitespace-nowrap" data-id="element-155">
            OFERTA DE LANZAMIENTO
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-10 mt-4" data-id="element-156">
            <div className="text-center md:text-left" data-id="element-157">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-158">
                Acceso Total e Inmediato
              </h3>
              <ul className="space-y-2 text-gray-300" data-id="element-159">
                <li className="flex items-center justify-center md:justify-start" data-id="element-160">
                  <ShieldCheck className="w-5 h-5 text-yellow-400 mr-2" data-id="element-161" /> Guía
                  Maestra (3 Días)
                </li>
                <li className="flex items-center justify-center md:justify-start" data-id="element-162">
                  <ShieldCheck className="w-5 h-5 text-yellow-400 mr-2" data-id="element-163" /> Bono
                  1: Baños y Despojos
                </li>
                <li className="flex items-center justify-center md:justify-start" data-id="element-164">
                  <ShieldCheck className="w-5 h-5 text-yellow-400 mr-2" data-id="element-165" /> Bono
                  2: Manifestación
                </li>
                <li className="flex items-center justify-center md:justify-start" data-id="element-166">
                  <ShieldCheck className="w-5 h-5 text-yellow-400 mr-2" data-id="element-167" /> Bono
                  3: Escudo 60 Segundos
                </li>
              </ul>
            </div>

            <div className="text-center bg-black/30 p-6 rounded-2xl border border-white/5 min-w-[250px]" data-id="element-168">
              <div className="text-gray-400 text-lg mb-1" data-id="element-169">
                Precio Regular:{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-170">
                  $67 USD
                </span>
              </div>
              <div className="text-sm text-yellow-400 font-semibold mb-2" data-id="element-171">
                Hoy por solo:
              </div>
              <div className="text-6xl font-black text-white mb-2 tracking-tight" data-id="element-172">
                ${totalPrice}
              </div>
            </div>
          </div>

          <div id="pricing-cta" className="text-center scroll-mt-8" data-id="element-173">
            <div onClick={handleCheckoutClick} className="inline-block w-full md:w-auto" data-id="element-174">
              <Button size="lg" href={!bump1 && !bump2 ? '#' : checkoutUrl} className="w-full md:w-auto md:px-16 py-5 text-xl mb-6 flex-col !leading-tight" onBeforeNavigate={trackInitiateCheckout} data-id="element-175">
                <span data-id="element-176">
                  ¡SÍ, QUIERO LIBERAR MI ENERGÍA AHORA! — ${totalPrice} USD
                </span>
                <span className="text-xs font-normal opacity-80 mt-1" data-id="element-177">
                  + impuestos según tu país
                </span>
              </Button>
            </div>

            <div className="flex items-center justify-center text-gray-400 text-sm space-x-2" data-id="element-178">
              <Lock className="w-4 h-4" data-id="element-179" />
              <span data-id="element-180">
                Acceso instantáneo y seguro. Tu privacidad está garantizada.
              </span>
            </div>
          </div>

          {/* Order Bumps */}
          <div className="mt-12 space-y-6" data-id="element-181">
            {/* Order Bump 1 */}
            <div className={`relative rounded-2xl border-2 transition-all duration-300 cursor-pointer overflow-hidden ${bump1 ? 'border-yellow-400 bg-#[\\#1a1f3a]/80 shadow-[0_0_30px_rgba(212,175,55,0.2)]' : 'border-white/10 bg-black/20 hover:border-white/20'}`} onClick={() => setBump1(!bump1)} data-id="element-182">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-400 to-yellow-600 opacity-50" data-id="element-183"></div>
              <div className="p-5 md:p-6 flex flex-col sm:flex-row gap-6" data-id="element-184">
                <div className="flex-shrink-0 w-full sm:w-28 h-40 sm:h-auto rounded-xl overflow-hidden border border-white\\/10 relative" data-id="element-185">
                  <img src="https://cdn.magicpatterns.com/uploads/8pkHRJ2hPsez5MNb1u6y4x/Reprogramacionpng.png" alt="Reprograma tu Mente" className="w-full h-full object-cover" data-id="element-186" />
                  <div className="absolute top-2 left-2 bg-yellow-500 text-slate-900 text-[10px] font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-187">
                    ¡Añade Esto!
                  </div>
                </div>

                <div className="flex-1" data-id="element-188">
                  <div className="flex justify-between items-start mb-2" data-id="element-189">
                    <h4 className="text-xl font-bold text-white pr-8" data-id="element-190">
                      Reprograma tu Mente y Activa tu Riqueza
                    </h4>
                    <div className="absolute top-5 right-5 sm:relative sm:top-0 sm:right-0" data-id="element-191">
                      {bump1 ? <CheckCircle className="w-7 h-7 text-yellow-400 fill-yellow-400/20" data-id="element-192" /> : <Circle className="w-7 h-7 text-gray-500" data-id="element-193" />}
                    </div>
                  </div>

                  <div className="text-yellow-400 font-bold text-lg mb-3" data-id="element-194">
                    + $7 USD
                  </div>

                  <ul className="space-y-2 text-sm text-gray-300 mb-4" data-id="element-195">
                    <li className="flex items-start" data-id="element-196">
                      <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-197" />
                      <span data-id="element-198">
                        ¿Trabajas mucho pero el dinero no fluye como debería?
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-199">
                      <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-200" />
                      <span data-id="element-201">
                        Descubre cómo reprogramar tu mente para atraer riqueza
                        real y sostenida.
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-202">
                      <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-203" />
                      <span data-id="element-204">
                        Elimina creencias limitantes y activa una mentalidad de
                        abundancia.
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-205">
                      <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-206" />
                      <span data-id="element-207">
                        Incluye ejercicios prácticos para transformar tu
                        realidad financiera desde hoy.
                      </span>
                    </li>
                  </ul>

                  <div className="flex items-center text-yellow-400 font-medium text-sm bg-yellow-500/10 p-3 rounded-lg border border-yellow-500/20" data-id="element-208">
                    <Rocket className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-209" />
                    Agrégalo ahora y comienza a crear la vida que realmente
                    mereces.
                  </div>
                </div>
              </div>
            </div>

            {/* Order Bump 2 */}
            <div className={`relative rounded-2xl border-2 transition-all duration-300 cursor-pointer overflow-hidden ${bump2 ? 'border-yellow-400 bg-#[\\#1a1f3a]/80 shadow-[0_0_30px_rgba(212,175,55,0.2)]' : 'border-white/10 bg-black/20 hover:border-white/20'}`} onClick={() => setBump2(!bump2)} data-id="element-210">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-400 to-yellow-600 opacity-50" data-id="element-211"></div>
              <div className="p-5 md:p-6 flex flex-col sm:flex-row gap-6" data-id="element-212">
                <div className="flex-shrink-0 w-full sm:w-28 h-40 sm:h-auto rounded-xl overflow-hidden border border-white\\/10 relative" data-id="element-213">
                  <img src="https://cdn.magicpatterns.com/uploads/x9HMusLw9ZiiSawuTgSm1J/Hombre.png" alt="Deja de Sanar" className="w-full h-full object-cover" data-id="element-214" />
                  <div className="absolute top-2 left-2 bg-yellow-500 text-slate-900 text-[10px] font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-215">
                    Oferta Especial
                  </div>
                </div>

                <div className="flex-1" data-id="element-216">
                  <div className="flex justify-between items-start mb-1" data-id="element-217">
                    <h4 className="text-xl font-bold text-white pr-8" data-id="element-218">
                      Deja de Sanar y Comienza a Cerrar para Concretar
                    </h4>
                    <div className="absolute top-5 right-5 sm:relative sm:top-0 sm:right-0" data-id="element-219">
                      {bump2 ? <CheckCircle className="w-7 h-7 text-yellow-400 fill-yellow-400/20" data-id="element-220" /> : <Circle className="w-7 h-7 text-gray-500" data-id="element-221" />}
                    </div>
                  </div>

                  <div className="text-yellow-400 font-bold text-lg mb-3" data-id="element-222">
                    + $7 USD
                  </div>

                  <ul className="space-y-2 text-sm text-gray-300 mb-4" data-id="element-223">
                    <li className="flex items-start" data-id="element-224">
                      <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-225" />
                      <span data-id="element-226">¿Cansado de sanar sin avanzar realmente?</span>
                    </li>
                    <li className="flex items-start" data-id="element-227">
                      <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-228" />
                      <span data-id="element-229">
                        Aprende a cerrar ciclos y liberarte del pasado de forma
                        definitiva.
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-230">
                      <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-231" />
                      <span data-id="element-232">
                        Reprograma tu mente y rompe patrones que bloquean tu
                        crecimiento.
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-233">
                      <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-234" />
                      <span data-id="element-235">
                        Incluye herramientas prácticas para transformar tu vida
                        en solo 21 días.
                      </span>
                    </li>
                  </ul>

                  <div className="flex items-center text-yellow-400 font-medium text-sm bg-yellow-500/10 p-3 rounded-lg border border-yellow-500/20" data-id="element-236">
                    <Sparkles className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-237" />
                    Agrégalo ahora y empieza a concretar la vida que mereces.
                  </div>
                </div>
              </div>
            </div>

            {/* Order Summary */}
            <div className="mt-8 bg-black/30 rounded-2xl border border-white/10 p-6" data-id="element-238">
              <div className="space-y-3" data-id="element-239">
                {/* Base product */}
                <div className="flex justify-between items-center text-gray-300" data-id="element-240">
                  <span data-id="element-241">Guía Maestra (3 Días)</span>
                  <span className="line-through decoration-red-500 decoration-2 text-gray-500" data-id="element-242">
                    $47.00
                  </span>
                </div>
                <div className="flex justify-between items-center text-gray-300" data-id="element-243">
                  <span data-id="element-244">3 Bonos Exclusivos</span>
                  <span className="line-through decoration-red-500 decoration-2 text-gray-500" data-id="element-245">
                    $20.00
                  </span>
                </div>

                {/* Bump 1 - conditional */}
                {bump1 && <div className="flex justify-between items-center text-yellow-400" data-id="element-246">
                    <span data-id="element-247">Reprograma tu Mente y Activa tu Riqueza</span>
                    <span data-id="element-248">$7.00</span>
                  </div>}

                {/* Bump 2 - conditional */}
                {bump2 && <div className="flex justify-between items-center text-yellow-400" data-id="element-249">
                    <span data-id="element-250">Deja de Sanar y Comienza a Cerrar</span>
                    <span data-id="element-251">$7.00</span>
                  </div>}

                {/* Divider */}
                <div className="border-t border-white/10 pt-3 mt-3" data-id="element-252">
                  <div className="flex justify-between items-center text-gray-300 font-bold" data-id="element-253">
                    <span data-id="element-254">Valor Total</span>
                    <span className="line-through decoration-red-500 decoration-2 text-gray-500" data-id="element-255">
                      ${originalTotal}.00
                    </span>
                  </div>
                </div>

                {/* Actual price */}
                <div className="flex justify-between items-center" data-id="element-256">
                  <span className="text-yellow-400 font-bold text-lg" data-id="element-257">
                    Hoy pagas solo
                  </span>
                  <span className="text-yellow-400 font-black text-2xl" data-id="element-258">
                    ${totalPrice}.00
                  </span>
                </div>
              </div>
            </div>

            {/* Bottom CTA */}
            <div className="mt-8 text-center" data-id="element-259">
              <div onClick={handleCheckoutClick} className="inline-block w-full md:w-auto" data-id="element-260">
                <Button size="lg" href={!bump1 && !bump2 ? '#' : checkoutUrl} className="w-full md:w-auto md:px-16 py-5 text-xl mb-4 flex-col !leading-tight" onBeforeNavigate={trackInitiateCheckout} data-id="element-261">
                  <span data-id="element-262">
                    ¡SÍ, QUIERO LIBERAR MI ENERGÍA AHORA! — ${totalPrice} USD
                  </span>
                  <span className="text-xs font-normal opacity-80 mt-1" data-id="element-263">
                    + impuestos según tu país
                  </span>
                </Button>
              </div>
              <div className="flex items-center justify-center text-gray-400 text-sm space-x-2" data-id="element-264">
                <Lock className="w-4 h-4" data-id="element-265" />
                <span data-id="element-266">
                  Acceso instantáneo y seguro. Tu privacidad está garantizada.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}